/* ../lib/components/routes/Mock.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	create_component,
	destroy_component,
	init,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "svelte/internal";

import MockView from "../parts/MockView/MockView";

function create_fragment(ctx) {
	let current;

	const mockview = new MockView({
			props: {
				src: /*mockUrl*/ ctx[0],
				target: /*target*/ ctx[1]
			}
		});

	return {
		c() {
			create_component(mockview.$$.fragment);
		},
		m(target, anchor) {
			mount_component(mockview, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(mockview.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(mockview.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(mockview, detaching);
		}
	};
}

function instance($$self) {
	const viewInfoEncoded = location.hash.replace(/^#\//, "");
	const viewInfoJson = decodeURIComponent(viewInfoEncoded);
	const { mockUrl, target } = JSON.parse(viewInfoJson);
	return [mockUrl, target];
}

class Mock extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Mock;